export function isPaylaterMessageRequired(country) {
  switch (country) {
    case 'US':
      return true
    case 'Canada':
      return false
    case 'MX':
      return false
    case 'IN':
      return false
    default:
      return true
  }
}
